module.exports = __webpack_public_path__ + "img/siemssen.0847e84b.jpg";